import React from 'react';
import { Table } from 'react-bootstrap';

const TabJustificativas = ({ justificativas }) => {
  if (!justificativas || justificativas.length === 0) {
    return <div className="text-muted p-3">Nenhuma justificativa vinculada a este título.</div>;
  }

  return (
    <Table striped bordered hover size="sm">
      <thead>
        <tr>
          <th>Código</th>
          <th>Descrição</th>
        </tr>
      </thead>
      <tbody>
        {justificativas.map((j) => (
          <tr key={j.codigo_justificativa}>
            <td>{j.codigo_justificativa}</td>
            <td>{j.descricao_justificativa}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default TabJustificativas;
